import { render, staticRenderFns } from "./OwnersListController.vue?vue&type=template&id=01ce34d1&scoped=true&"
import script from "./OwnersListController.vue?vue&type=script&lang=ts&"
export * from "./OwnersListController.vue?vue&type=script&lang=ts&"
import style0 from "./owners-list-controller.scss?vue&type=style&index=0&id=01ce34d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ce34d1",
  null
  
)

export default component.exports